export default __webpack_public_path__ + "static/856-b1b2cac0b86d43c4744d291447c7f91d.gif";